export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-home-heart-fill',
      title: 'Family Owned & Operated',
      description: 'Local family business serving our community with pride since 2006. Your neighbors you can trust.'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Licensed & Insured',
      description: 'Fully licensed, bonded, and insured for your peace of mind and protection on every job.'
    },
    {
      icon: 'ri-time-fill',
      title: 'Fast Same-Day Service',
      description: 'We understand AC emergencies. Same-day service available to get you comfortable quickly.'
    },
    {
      icon: 'ri-star-fill',
      title: 'Experienced Technicians',
      description: 'Our skilled team has decades of combined experience handling all HVAC brands and models.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Upfront Pricing',
      description: 'No hidden fees or surprises. We provide clear, honest pricing before any work begins.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Side */}
          <div className="lg:col-span-2 relative">
            <div className="text-[180px] font-bold text-gray-200 absolute -top-20 -left-4 select-none">
              2006
            </div>
            <div className="relative z-10">
              <p className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3">
                WHY DOOLITTLE AIR
              </p>
              <h2 className="text-5xl font-bold text-slate-900 mb-6 font-serif">
                Family-Owned Excellence You Can Trust
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                For nearly two decades, we've been keeping Southwest Florida homes comfortable with honest service, expert care, and a commitment to treating every customer like family. When you choose Doolittle Air, you're choosing quality, reliability, and peace of mind.
              </p>
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/39db98e10fc68c0119ffb772701bf745.jpg"
                  alt="Doolittle Air Team"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="lg:col-span-3 space-y-10">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-6 group">
                <div className="w-14 h-14 flex-shrink-0 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}